exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2Nv84_1sdWh4H6AUKsTsLB{font-size:14px;line-height:20px;padding:15px;display:flex;flex-direction:row;text-align:left;color:#424242;border-bottom:1px solid #e0e0e0}._3Qrghs8INWMelok73A-1GC{flex:1 1 auto}._1a5jUnz8TlDyDYxx8o3hlF{flex:0 1 100px;height:100px}._11EhGo6RdDYLAvyHWCzmzj{font-weight:500;color:#616161}._1hb-zDUqFPu3Com0NvHt0E{font-size:18px;line-height:22px;font-weight:500}._1hb-zDUqFPu3Com0NvHt0E a{text-decoration:none}._216omPJnN7KW8X4PBrS1kY{color:#727272}._19tdFGOHAgjbaqAGya87IV{font-size:18px;line-height:22px;color:#616161;margin:3em 1em;text-align:center}\n", ""]);

// Exports
exports.locals = {
	"EventsRow": "_2Nv84_1sdWh4H6AUKsTsLB",
	"left": "_3Qrghs8INWMelok73A-1GC",
	"right": "_1a5jUnz8TlDyDYxx8o3hlF",
	"timespan": "_11EhGo6RdDYLAvyHWCzmzj",
	"name": "_1hb-zDUqFPu3Com0NvHt0E",
	"icon": "_216omPJnN7KW8X4PBrS1kY",
	"emptyList": "_19tdFGOHAgjbaqAGya87IV"
};